"use client";

import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function HeroSection() {
  return <section id="hero-section" className="relative w-full bg-background min-h-[60vh] flex items-center justify-center py-20">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/hero_background.png)]" aria-hidden="true">
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {}
      <div className="relative z-10 w-full max-w-6xl px-6 sm:px-8 lg:px-12 flex flex-col items-center text-center">
        {}
        <div className="mb-8 w-full flex justify-center">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/" className="text-white/80 hover:text-white">
                    Home
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="[&>svg]:text-white/60" />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-white">Über uns</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-default font-bold text-white mb-4">
          Über Renovierungen Schneider
        </h1>

        {}
        <p className="text-base sm:text-lg text-white/90 max-w-2xl">
          Ihr zuverlässiger Partner für Renovierung und Sanierung im Raum Köln
        </p>
      </div>
    </section>;
}